<template>
  <svg
    width="24"
    height="17"
    viewBox="0 0 24 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_340_497)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.237 0.605957C13.531 0.610957 19.703 0.655957 21.375 1.08296C22.408 1.34496 23.22 2.11896 23.498 3.10296C23.998 4.88596 23.998 8.60596 23.998 8.60596V8.61696C23.998 8.83696 23.982 12.38 23.498 14.107C23.22 15.09 22.408 15.865 21.375 16.128C19.663 16.565 13.235 16.602 12.153 16.605H11.843C10.761 16.602 4.33305 16.565 2.62305 16.128C1.58805 15.865 0.775047 15.09 0.500047 14.107C0.0450468 12.492 0.00204688 9.28696 -0.00195312 8.69896V8.51196C0.00204688 7.92496 0.0450468 4.71796 0.500047 3.10296C0.776047 2.11896 1.58805 1.34496 2.62205 1.08296C4.29405 0.656957 10.465 0.610957 11.76 0.606957L12.237 0.605957ZM9.59805 5.17596V12.033L15.833 8.60496L9.59805 5.17596Z"
        fill="url(#paint0_linear_340_497)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_340_497"
        x1="-0.00195313"
        y1="0.605957"
        x2="28.9098"
        y2="39.7084"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="CurrentColor" />
        <stop offset="1" stop-color="CurrentColor" />
      </linearGradient>
      <clipPath id="clip0_340_497">
        <rect
          width="24"
          height="16"
          fill="CurrentColor"
          transform="translate(0 0.606934)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {};
</script>

<style>
</style>